import { QueryClient, QueryClientProvider } from "react-query";
import { Outlet } from "react-router-dom";
import { AuthProvider } from "./context/auth.context";
import { Toaster } from "sonner";
import { OrganizationProvider } from "./context/organization.context";
import { NuqsAdapter } from "nuqs/adapters/react-router/v6";
import { ModuleProvider } from "./context/modules.context";
import { IntegrationProvider } from "./context/integrations.context";
import { CurrencyProvider } from "./context/currency.contect";
import { LanguageProvider } from "./context/language.context";
import { ThemeProvider } from "./components/theme-provider";
import { useEffect } from "react";
import { env_config } from "./env-config";
import { ErrorBoundary } from "./components/ErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  useEffect(() => {
    const root = document.documentElement;

    root.style.setProperty(
      "--primary",
      env_config[import.meta.env.VITE_APP_ENVIRONMENT].primaryColor,
    );
    // primary dark
    root.style.setProperty(
      "--primary-dark",
      env_config[import.meta.env.VITE_APP_ENVIRONMENT].primaryDark,
    );
  }, []);

  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
      <ErrorBoundary>
        <NuqsAdapter>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <OrganizationProvider>
                <ModuleProvider>
                  <IntegrationProvider>
                    <CurrencyProvider>
                      <LanguageProvider>
                        <Toaster
                          toastOptions={{
                            classNames: {
                              error: "!bg-red-50 !text-red-400 border-red-500",
                              info: "bg-orange-400",
                              success:
                                "!bg-green-50 !text-green-400 !border-green-500",
                              warning: "bg-orange-400 border-green-500",
                              toast: "bg-orange-400",
                              title: "text-sm font-sans",
                              actionButton: "bg-zinc-400",
                              cancelButton: "bg-orange-400",
                              closeButton: "bg-lime-400",
                            },
                          }}
                        />
                        <Outlet />
                      </LanguageProvider>
                    </CurrencyProvider>
                  </IntegrationProvider>
                </ModuleProvider>
              </OrganizationProvider>
            </AuthProvider>
          </QueryClientProvider>
        </NuqsAdapter>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
